export const jsonMap={
	// "title":" ",
	// "description":"Accessibility of open spaces  " ,
	// "logoPosition": "right",
	// "logo":"/manitLogo.png",
	// "logoWidth":60,
	// "logoHeight":60,
	// "showQuestionNumbers":"off",
	"pages": [
	 {
	  "name": "page1",
	  "elements": [
	   {
	    "type": "text",
	    "name": "question50",
	    "title": "Survey No",
	    "isRequired": true,
	    "maxlength":3,
	   },
	   
	] 
	 } 
	  
	] 
       };
